import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [
    import('./viewer/StripSlideshow' /* webpackChunkName: "StripSlideshow" */),
    import(
      './viewer/StripSlideshow.controller' /* webpackChunkName: "StripSlideshow" */
    ),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('StripSlideshow', UiTypes),
};

export default entry;
